package com.cybersoftsolution.cybersoftsolutionweb.components.cards

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.border
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.style
import org.jetbrains.compose.web.css.textAlign
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun DevelopmentModeCard(){
    Div({
        style {
            textAlign("center")
            padding(20.px)
            backgroundColor(Color("#f0f0f0")) // o rgb(240, 240, 240)
            border {
                width(1.px)
                style(LineStyle.Solid)
                color(Color("#ccc")) // o rgb(204, 204, 204)
            }
        }
    }) {
        H1 { Text("Sitio en desarrollo") }
        P { Text("Estamos trabajando para ofrecerte una mejor experiencia. Vuelve pronto.") }
    }
}